<template lang="pug">
div
	h1 {{contentpage.name}}
	v-alert(type="error" v-if="!contentpage.isActive") Let op! Deze pagina is nog niet actief en alleen zichtbaar voor admins

	ws-content(:value="contentpage.content")


</template>
<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const getContentpageWithPath = gql`
	query getContentpageWithPath($path: String!) {
		contentpage(path: $path) {
			id
			name
			slug
			isActive
			content {
				...ContentDataFragment
			}
			parents {
				id
				name
				slug
				path
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/*',
			'de-DE': '/*',
			'nl-BE': '/*'
		}
	},
	async middleware({ app, route, error, redirect }) {
		await app.$graphClient
			.query({
				query: gql`
					query getContentpageWithPathRedirect($path: String!) {
						contentpage(path: $path) {
							id
							...MetaFragment
						}
					}
					${MetaFragment}
				`,
				variables: {
					path: route.path,
					context: {
						isMiddleware: true
					}
				}
			})
			.then(({ data }) => {
				// TODO: Dit zou een losse resolver kunnen worden zodat we dit voor meer types kunnen gebruiken.
				// https://trello.com/c/NanPoj3R/4364-statuscodeforpath-resolver

				if (!data.contentpage) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				if (data.contentpage.meta.redirect) {
					return redirect(302, data.contentpage.meta.redirect);
				}
			})
			.catch(error => {
				if (error.message.includes('no content page found with slug')) {
					return app.httpError(404, null, 'contentpage-index-00', error);
				}

				return app.httpError(500, null, 'contentpage-index-02', error);
			});
	},
	asyncData({ app, route }) {
		app.ads({ sidebar: { visible: true } });

		return app.$graphClient
			.query({
				query: getContentpageWithPath,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				app.meta(data.contentpage.meta);

				const crumbs = {};

				if (data.contentpage.parents) {
					[...data.contentpage.parents].reverse().forEach(parent => {
						crumbs[parent.name] = {
							name: 'contentpage',
							params: { 0: parent.path.slice(1) }
						};
					});
				}

				crumbs[data.contentpage.name] = {
					name: 'contentpage',
					params: { 0: route.path.slice(1) }
				};

				app.breadcrumbs(crumbs);

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'contentpage-index-01', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
